import { render, staticRenderFns } from "./NeuroStandardsTimeline.vue?vue&type=template&id=3dadd979&scoped=true"
import script from "./NeuroStandardsTimeline.vue?vue&type=script&lang=js"
export * from "./NeuroStandardsTimeline.vue?vue&type=script&lang=js"
import style0 from "./NeuroStandardsTimeline.vue?vue&type=style&index=0&id=3dadd979&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dadd979",
  null
  
)

export default component.exports